import { render, staticRenderFns } from "./SelectorAsientoComponent.vue?vue&type=template&id=db48abca&scoped=true"
import script from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
export * from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectorAsientoComponent.vue?vue&type=style&index=0&id=db48abca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db48abca",
  null
  
)

export default component.exports